/*
 * File: Card.jsx
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 4, 2022 at 4:30 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: May 21, 2024 at 10:38 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import * as S from './Card.styles';


/**
 * Component
 */

export const Card = ({ className, children, ...rest }) => (
	<S.Card className={className} {...rest}>
		{children}
	</S.Card>
);


/**
 * Configuration
 */

Card.displayName = 'Card';
Card.propTypes = {
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
Card.defaultProps = {
	className: null,
	children: null
};
